__turbopack_context__.v({
  "item": "KineticTitle-module__c0Ghoq__item",
});
